<template>
    <div class="input-wrap" :class="{error: field.validation.error, disabled: disabled}">
        <div class="label-wrap">
            <label :for="field.name">{{label}}<span v-if="field.validation.required">*</span></label>
            <div class="toggle">
                <a href="" :class="{selected : valMatchesCV}" @click.prevent="selectCV" v-if="valMatchesCV != null" :title="cvMatchTitle">CV</a>
                <a href="" :class="{selected : valMatchesSF}" @click.prevent="selectSF" v-if="valMatchesSF != null" :title="sfMatchTitle">SF</a>
            </div>
        </div>

        <select :id="field.name" :class="{changed:field.value !== field.initialValue}" :attr="selectProps"
                v-model="field.value" @change="this.change">
            <option :selected="!field.value" value="">Please select...</option>
            <option v-for="(option, index) in options" :value="option.value" :key="index">
                {{ option.label }}
            </option>
        </select>
        <div class="error">{{field.validation.error}}</div>
    </div>
</template>

<script>
    export default {
        name: "InputSelect",
        props: {
            field: {
                type: Object
            },
            label: {
                type: String
            },
            options: {
                type: Array,
                default: function() { return [
                    {label: 'Yes', value: 'Yes'},
                    {label: 'No', value: 'No'}
                ];}
            },
            flexibleOptions: {
                type: Boolean,
                default: false
            },
            selectProps: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            },
            src: {
                type: Object,
                default: null
            }
        },
        computed: {
            val() {
                return this.field.value;
            },
            valMatchesCV() {
                if(this.field && this.src && this.src.cv != null) {
                    return this.field.value === this.src.cv;
                }
                return null;
            },
            valMatchesSF() {
                if(this.field && this.src && this.src.sf != null) {
                    return this.field.value === this.src.sf;
                }
                return null;
            },
            cvMatchTitle(){
                if(this.valMatchesCV){
                    return 'This value matches the CV';
                } else {
                    return 'Replace with value from CV';
                }
            },
            sfMatchTitle(){
                if(this.valMatchesSF){
                    return 'This value matches the Salesforce record';
                } else {
                    return 'Replace with value from Salesforce';
                }
            }
        },
        mounted: function () {
            this.checkWithinOptions();
            //Checks for default in options, and sets it if no other value is set
            if (!this.field.value){
                for (let i = 0; i < this.options.length; i++){
                    if (this.options[i].isDefault) {
                        this.field.value = this.field.initialValue = this.options[i].value;
                    }
                }
            }
        },
        methods: {
            change() {
                this.$emit('onChange', this.field);
                this.checkWithinOptions();
                this.field.validate();
            },
            checkWithinOptions(){
                let found = false;
                for (let i = 0; i < this.options.length; i++){
                    if (this.field.value === this.options[i].value){
                        found = true;
                    }
                }
                if (!found) {
                    if (this.flexibleOptions){
                        this.addValueToOptions(this.field.value);
                    } else {
                        this.field.value = '';
                    }
                }
            },
            addValueToOptions(val){
                this.options.push(
                    {
                        isDefault: false,
                        label: val,
                        value: val
                    }
                );
            },
            selectCV() {
                this.field.value = this.src.cv;
            },
            selectSF() {
                this.field.value = this.src.sf;
            }
        },
        watch: {
            val(newVal) {
                let valid = false;
                for (let i = 0; i < this.options.length; i++) {
                    if (this.options[i].value === newVal) {
                        valid = true;
                        break;
                    }
                }
                if (!valid){
                    this.field.value = '';
                }
                
            }
        }
    };
</script>

<style scoped>

    .label-wrap {display: flex; justify-content: space-between;}
        .label-wrap > * {align-self: flex-end;}

        .toggle > a {font-size: .7rem; font-weight: bold; text-transform: uppercase; margin-bottom: .25rem; /*border-bottom: solid 1px var(--colour-primary);*/ text-decoration: none; display: inline-block; transition: .25s;}
        .toggle > a + a {margin-left: .3rem;}
        .toggle > a.selected:hover {cursor: default;}
        .toggle > a:not(.selected) {color: #000; border-bottom: solid 1px transparent; opacity: .25;}
        .toggle > a:not(.selected):hover {border-bottom: solid 1px #000;}

    .changed { background-color: #93c57a; }
    
</style>